import React from "react";
import AssetsProvider from "providers/AssetsProvider";
import TraitSalesProvider from "providers/TraitSalesProvider";
import TraitsProvider from "providers/TraitsProvider";
import CacheProvider from "providers/CacheProvider";
import VestingProvider from "providers/VestingProvider";
import SaleProvider from "providers/SaleProvider";
import HiveProvider from "providers/HiveProvider";

const ComposedConnectedProviders: React.FC = ({ children }) => (
  <CacheProvider>
    <AssetsProvider>
      <VestingProvider>
        <HiveProvider>
          <SaleProvider>
            <TraitsProvider>
              <TraitSalesProvider>{children}</TraitSalesProvider>
            </TraitsProvider>
          </SaleProvider>
        </HiveProvider>
      </VestingProvider>
    </AssetsProvider>
  </CacheProvider>
);

export default ComposedConnectedProviders;
